const Datastore = require('nedb')

let appointments = new Datastore({ filename: "./appointments.db", autoload: true });

//appointments.remove({});

export default appointments;


// WEBPACK FOOTER //
// ./src/services/appointments/index.js